import { NgModule } from '@angular/core';
import {
    OrderModePipe, OrderStatusPipe, InstrumentTypePipe,
    OrderValidityPipe, OrderTypePipe, ProductTypePipe,
    OrderModePipeString
} from './acronym-pipes';

@NgModule({
    imports: [],
    declarations: [
        InstrumentTypePipe,
        OrderStatusPipe,
        OrderModePipe,
        OrderValidityPipe,
        OrderTypePipe,
        ProductTypePipe,
        OrderModePipeString
    ],
    exports: [
        InstrumentTypePipe,
        OrderStatusPipe,
        OrderModePipe,
        OrderValidityPipe,
        OrderTypePipe,
        ProductTypePipe,
        OrderModePipeString
    ]
})
export class AcronymModule { }
